import { render } from "./QuickpayPaymentOverview.vue?vue&type=template&id=8867af20&scoped=true"
import script from "./QuickpayPaymentOverview.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentOverview.vue?vue&type=script&lang=js"

import "./QuickpayPaymentOverview.vue?vue&type=style&index=0&id=8867af20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8867af20"]])

export default __exports__